export default __webpack_public_path__ + "static/tcofs-b3cf13a4dd8c7d040496a910ddbca228.jpg";